export default __webpack_public_path__ + "static/media/bg.3d421b1b.png";